import { ref, computed, getCurrentInstance } from 'vue';
import { deepClone } from '@/utils/api';

export const usePersonalFields = () => {
	const { proxy } = getCurrentInstance();
	const personalFields = ref([]);

	const getCustomFields = computed(() => {
		return personalFields.value.filter(item => item.fieldType === 1);
	});

	const getSystemField = systemType => {
		return personalFields.value.find(item => Number(item.systemType) === systemType);
	};

	const getSystemFieldValue = systemType => {
		return getSystemField(systemType)?.dynamicFieldValue;
	};

	const initDynamicField = configVO => {
		const fieldConfig = configVO?.fieldConfig;
		if (!Array.isArray(fieldConfig)) {
			personalFields.value = [];
			return;
		}

		// 1:显示且必填、2:显示非必填、3:不展示
		const isConfigClosed = config => config === 3;
		personalFields.value = fieldConfig
			.map(group => (Array.isArray(group) && group.length > 0 ? group[0] : null))
			.filter(item => !!item)
			.filter(item => !isConfigClosed(item.config))
			.filter(item => !!item.dynamicFieldName)
			.sort((a, b) => a.sort - b.sort);
	};

	const validateFields = fields => {
		return (fields || []).some(item => {
			if (item.config !== 1) return false; // 非必填跳过

			// type=5 (文件)需要特殊处理，解析 JSON
			if (item.fieldType === 1 && item.type === 5) {
				try {
					const files = item.dynamicFieldValue ? JSON.parse(item.dynamicFieldValue) : [];
					return files.length === 0;
				} catch {
					return true;
				}
			}

			// 其他类型，检查是否为空
			return !item.dynamicFieldValue;
		});
	};

	const processCustomFields = () => {
		const customFields = deepClone(getCustomFields.value);
		return (customFields || []).map(item => {
			// 处理选项类字段
			if ([1, 2].includes(item.type)) {
				let { dynamicFieldValue, conditionOptionVOList, ...rest } = item;
				if (dynamicFieldValue) {
					const indexes = dynamicFieldValue
						.split(',')
						.filter(v => v !== '')
						.map(v => parseInt(v));
					conditionOptionVOList = (conditionOptionVOList || []).filter((_, idx) => indexes.includes(idx));
				} else {
					conditionOptionVOList = [];
				}
				return {
					...rest,
					conditionOptionVOList
				};
			}

			return item;
		});
	};

	// 字段配置留存
	const cacheDynamicFieldConfig = ref({});
	const saveCacheDynamicFieldConfig = config => {
		proxy.$set(cacheDynamicFieldConfig.value, 'dynamicFieldConfigVO', deepClone(config));
	};
	const getCacheDynamicFieldConfig = () => {
		return cacheDynamicFieldConfig.value?.dynamicFieldConfigVO;
	};

	return {
		personalFields,
		getCustomFields,

		getSystemField,
		getSystemFieldValue,
		initDynamicField,
		validateFields,
		processCustomFields,

		cacheDynamicFieldConfig,
		saveCacheDynamicFieldConfig,
		getCacheDynamicFieldConfig
	};
};
